<div class="content-mobile">
  <ol start="1">
    <li>
      <span>
        {{
          instructionOneMobile || "Open your preferred authentication App."
        }}</span
      >
      <metodh-auth></metodh-auth>
    </li>
    <li>
      <span>
        {{
          instructionTwoMobile ||
            "Enter the name of the account record in the first field (in the case of Google or Microsoft)."
        }}
      </span>
      <textarea
        class="text-copy"
        disabled="true"
        [(ngModel)]="valueCode"
      ></textarea>
    </li>
    <li>
      {{
        instructionTreeMobile || "Enter the following secret in the key field."
      }}
    </li>
    <li>
      {{
        instructionFourMobile ||
          "Select “Based on time” in the key type field.(in the case of Google)."
      }}
    </li>
    <li>
      {{
        instructionFiveMobile ||
          "Enter the generated TOTP Code into the input “Authentication code”."
      }}
    </li>
    <li>{{ instructionSixMobile || "Tap on Check to confirm." }}</li>
  </ol>
</div>
